import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';

@inject(stores => ({
  confirmationDialog: stores.app.confirmationDialog,
}))
@observer
export class ConfirmationDialog extends React.Component {
  getMessages() {
    const { confirmationDialog } = this.props;
    if(confirmationDialog.message && confirmationDialog.message.map) {
      return confirmationDialog.message;
    } else {
      return (
        <div className="confirmation-message-item">
          {confirmationDialog.message}
        </div>
      )
    }
  }

  render() {
    const { confirmationDialog } = this.props;
    return (
      <div>
        <div className={"confirmation-modal-container" + (confirmationDialog.isActive ? " active" : "")}>
          <div className="confirmation-wrapper">
            <div className="confirmation-modal-close" onClick={this.dismissErrors}><i className="fa fa-times"></i></div>
            {this.getMessages()}
            <div className="confirmation-modal-actions">
              {confirmationDialog.buttons.map(btn => {
                return <button id="btn-modalconfirm-ok" onClick={() => confirmationDialog.resolve(btn.value)} className={btn.className}>
                  {btn.label}
                </button>
              })}
            </div> 
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/ConfirmationDialog.js